<h1>Profile Image</h1>

<ngx-dropzone [accept]="acceptedImageTypes" (change)="onSelect($event)" [multiple]='false'>
    <ngx-dropzone-label>Profile Image</ngx-dropzone-label>
    <ngx-dropzone-preview *ngFor="let f of files"
    [multiple]='false' [removable]="true" (removed)="onRemove(f)">
      <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>

  <button mat-button class="fuse-mat-button-large mt-3" 
    style="margin-left: 0%;"  
  (click)="UploadDocument()">Submit</button>
  &nbsp;&nbsp;&nbsp;
  <button mat-button class="fuse-mat-button-large mt-3" 
    style="margin-left: 0%;"  
  (click)="CloseClick()">Close</button>